import React from 'react';
import { SvgProp } from './types';

export const BoldIcon: React.FC<SvgProp> = ({ onClick, width, height, fill }) => {
  return (
    <svg
      width={width ?? '9'}
      height={height ?? '12'}
      viewBox="0 0 9 12"
      fill={fill ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M6.808 6.192C7.78933 6.75733 8.28 7.61067 8.28 8.752C8.28 9.70133 7.944 10.48 7.272 11.088C6.6 11.696 5.77333 12 4.792 12H0.0400001V0.799999H4.456C5.416 0.799999 6.22133 1.09867 6.872 1.696C7.53333 2.28267 7.864 3.03467 7.864 3.952C7.864 4.88 7.512 5.62667 6.808 6.192ZM4.456 2.864H2.248V5.328H4.456C4.79733 5.328 5.08 5.21067 5.304 4.976C5.53867 4.74133 5.656 4.448 5.656 4.096C5.656 3.744 5.544 3.45067 5.32 3.216C5.096 2.98133 4.808 2.864 4.456 2.864ZM4.792 9.936C5.16533 9.936 5.47467 9.81333 5.72 9.568C5.96533 9.312 6.088 8.992 6.088 8.608C6.088 8.23467 5.96533 7.92533 5.72 7.68C5.47467 7.424 5.16533 7.296 4.792 7.296H2.248V9.936H4.792Z"
        fill="black"
      />
    </svg>
  );
};
